module.exports = __webpack_public_path__ + "img/p_1.75b26d50.jpg";